import { SITE_INTEGRATION_TYPE } from "@shared/common/constant/site";
import { SiteIntegrationSignupInitialValues } from "@shared/common/types/site";
import { getCsrfToken } from "next-auth/react";

export const getSignupInitialValues = async (
  integrationType: SITE_INTEGRATION_TYPE,
  tokenId: string
): Promise<SiteIntegrationSignupInitialValues> => {
  switch (integrationType) {
    case SITE_INTEGRATION_TYPE.CAFE24: {
      const csrfToken = await getCsrfToken();

      const res = await fetch(
        `/api/cafe24/signup-initial-values?token=${tokenId}&csrf_token=${csrfToken}`
      );

      if (!res.ok) {
        throw new Error("Failed to fetch cafe24 signup initial values");
      }

      return res.json();
    }

    case SITE_INTEGRATION_TYPE.NHN: {
      const csrfToken = await getCsrfToken();

      const res = await fetch(
        `/api/nhn/signup-initial-values?token=${tokenId}&csrf_token=${csrfToken}`
      );

      if (!res.ok) {
        throw new Error("Failed to fetch nhn signup initial values");
      }

      return res.json();
    }

    case SITE_INTEGRATION_TYPE.MAKESHOP:
    case SITE_INTEGRATION_TYPE.GODOMALL: {
      const result: SiteIntegrationSignupInitialValues = {
        phone: null,
        email: null,
        website: null,
      };
      return result;
    }

    case SITE_INTEGRATION_TYPE.WORDPRESS: {
      const csrfToken = (await getCsrfToken()) || "";
      const searchParams = new URLSearchParams();
      searchParams.set("token", tokenId);
      searchParams.set("csrf_token", csrfToken);

      const res = await fetch(
        `/api/wordpress/signup-initial-values?${searchParams.toString()}`
      );

      if (!res.ok) {
        throw new Error("Failed to fetch wordpress signup initial values");
      }

      return res.json();
    }

    case SITE_INTEGRATION_TYPE.SIXSHOP_PRO: {
      const csrfToken = (await getCsrfToken()) || "";
      const searchParams = new URLSearchParams();
      searchParams.set("token", tokenId);
      searchParams.set("csrf_token", csrfToken);

      const res = await fetch(
        `/api/sixshop-pro/signup-initial-values?${searchParams.toString()}`
      );

      if (!res.ok) {
        throw new Error("Failed to fetch sixshop pro signup initial values");
      }

      return res.json();
    }

    case SITE_INTEGRATION_TYPE.SIXSHOP:
    case SITE_INTEGRATION_TYPE.SHOPIFY:
      throw new Error("Not supported yet");
  }
};
